<app-default-layout
  [title]="'TICKETS.TITEL'"
>

  <div class="row">
    <div class="col-md-8 offset-md-2">
      <div class="frame frame-default" >

        @if(ticketListForm) {

          <form [formGroup]="ticketListForm" class="form-horizontal" accept-charset="UTF-8">

            <div class="flex d-flex">
              <app-custom-input id="suche"
                                type="text"
                                [style]="'width: 100%'"
                                [customFormGroup]="ticketListForm"
                                [clearable]="true"
                                [placeholder]="'TICKETS.SUCHE.PLACEHOLDER'|translate"
                                (onClear)="this.onClearSearchTerm()"
                                (onInput)="this.onSearchChange()"
                                [disabled]="false"
                                data-cy="suche"
              ></app-custom-input>
              <button class="btn btn-secondary btn-search-icon" (click)="this.onSearchChange()">
                <fa-icon [icon]="faSearch"></fa-icon>
              </button>
            </div>

            <div class="row mb-4">

              @if(isSearching){
                <div data-cy="info-is-searching">
                  {{'TICKETS.SUCHE.IS_SEARCHING'|translate}}
                </div>
                <div class="shimmer-line"></div>
              }
              @else {
                @if(responseDto?.numberOfElements>0)
                {
                  @for (studentTicket of this.responseDto.content; track studentTicket) {
                    <app-ticket-card [ticket]="studentTicket"
                                     (onCardContentChanged)="this.reloadTickets()"
                    ></app-ticket-card>
                  }

                  <app-pagination class="flex-wrap d-flex justify-content-end"
                                  [totalItems]="this.responseDto.totalElements"
                                  [pageSize]="this.responseDto.size"
                                  [currentPage]="this.responseDto.number+1 "
                                  (pageChange)="onPageChange($event)"
                                  data-cy="pagination-component"
                  ></app-pagination>
                }
                @else {
                  <div data-cy="info-no-results">
                    {{'TICKETS.SUCHE.NO_RESULTS'|translate}}
                  </div>
                }
              }

            </div>

          </form>
        }

      </div>
    </div>
  </div>

</app-default-layout>


